import { CompleteChallengesReducer } from '../interfaces';
import { createReducer } from '@reduxjs/toolkit';

const initialState: CompleteChallengesReducer = {
  status: {
    loading: false,
    error: false,
    done: false,
  },
  data: null,
};

const usageReducer = createReducer(initialState, {
  COMPLETE_CHALLENGE_PENDING: (state) => {
    state.status = {
      loading: true,
      error: false,
      done: false,
    };
  },

  COMPLETE_CHALLENGE_FULFILLED: (state, action) => {
    state.status = {
      loading: false,
      error: false,
      done: true,
    };
    state.data = action.payload.data;
  },

  COMPLETE_CHALLENGE_REJECTED: (state, action) => {
    state.status = {
      loading: false,
      error: true,
      done: false,
    };
    state.data = action.payload.data;
  },
});

export default usageReducer;
